var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "amprocess pb-1" }, [
    !_vm.isDataLoaded
      ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
      : _c("div", [
          !_vm.showAmpTable
            ? _c("div", { staticClass: "flex-row" })
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "flex-row flex-6 flex-justify-center" },
                  [
                    _c("div", { staticClass: "flex-col flex-1" }, [
                      _c("table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _c(
                              "th",
                              {
                                staticClass: "mainheader bl br pb-2",
                                attrs: { colspan: "7" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("maintenanceStrategyAndRisk"))
                                ),
                              ]
                            ),
                            _c("th", { staticClass: "br" }),
                            _c("th"),
                            _c(
                              "th",
                              {
                                staticClass: "mainheader bl br pb-2",
                                attrs: { colspan: "9" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("digitalizationComplianceAndSupport")
                                  )
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "tr",
                            [
                              _c("th"),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel) {
                                  return _c(
                                    "th",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "sub-category",
                                    },
                                    [
                                      _c("div", { staticClass: "rotate" }, [
                                        _vm._v(_vm._s(decisionModel.category)),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                        _c("tbody", [
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category bt bb br" }, [
                                _vm._v(_vm._s(_vm.grow)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        bt: true,
                                        bb: true,
                                        br: _vm.isBorderRightRequired(index),
                                        darkGreenBox:
                                          decisionModel.process == _vm.grow,
                                      },
                                    },
                                    [
                                      decisionModel.process === "Grow Value"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "tooltiptext" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        decisionModel.description ||
                                                          _vm.$t(
                                                            "noDecriptionAvaliable"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category bt bb br" }, [
                                _vm._v(_vm._s(_vm.maintain)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        bt: true,
                                        bb: true,
                                        br: _vm.isBorderRightRequired(index),
                                        lightGreenBox:
                                          decisionModel.process == _vm.maintain,
                                      },
                                    },
                                    [
                                      decisionModel.process === "Maintain Value"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "tooltiptext" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        decisionModel.description ||
                                                          _vm.$t(
                                                            "noDecriptionAvaliable"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category bt bb br" }, [
                                _vm._v(_vm._s(_vm.keepOption)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        bt: true,
                                        bb: true,
                                        br: _vm.isBorderRightRequired(index),
                                        yellowBox:
                                          decisionModel.process ==
                                          _vm.keepOption,
                                      },
                                    },
                                    [
                                      decisionModel.process === "Keep Option"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "tooltiptext" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        decisionModel.description ||
                                                          _vm.$t(
                                                            "noDecriptionAvaliable"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            [
                              _c("td", { staticClass: "category bt bb br" }, [
                                _vm._v(_vm._s(_vm.optimizeEol)),
                              ]),
                              _vm._l(
                                _vm.decisionModelListLocal,
                                function (decisionModel, index) {
                                  return _c(
                                    "td",
                                    {
                                      key: decisionModel.id,
                                      staticClass: "tooltip",
                                      class: {
                                        bt: true,
                                        bb: true,
                                        br: _vm.isBorderRightRequired(index),
                                        redBox:
                                          decisionModel.process ==
                                          _vm.optimizeEol,
                                      },
                                    },
                                    [
                                      decisionModel.process === "Optimize EOL"
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "tooltiptext" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "hover-box-title mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          decisionModel.category
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        decisionModel.description ||
                                                          _vm.$t(
                                                            "noDecriptionAvaliable"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }